import styled from "styled-components";

import { SkeletonBlock } from "components/admin";

export const SessionManagementModalContentStack = styled.div.attrs({ className: "space-y-4" })``;

export const SessionManagementModalSessionList = styled.div.attrs({ className: "grid gap-3" })``;

export const SessionManagementModalSessionCard = styled.div.attrs({
  className: "rounded-3xl border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] px-5 py-4",
})``;

export const SessionManagementModalSessionRow = styled.div.attrs({
  className: "flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between",
})``;

export const SessionManagementModalSessionDetails = styled.div.attrs({
  className: "min-w-0 space-y-2",
})``;

export const SessionManagementModalDeviceName = styled.p.attrs({
  className: "text-base font-semibold text-[var(--brand-ink)]",
})``;

export const SessionManagementModalInfoRow = styled.div.attrs({
  className: "flex flex-wrap items-center gap-2",
})``;

export const SessionManagementModalMetaText = styled.p.attrs({
  className: "text-sm text-[var(--brand-muted)]",
})``;

export const SessionManagementModalSessionActions = styled.div.attrs({
  className: "flex shrink-0 gap-2",
})``;

export const SessionManagementModalFooterActions = styled.div.attrs({
  className: "flex flex-wrap justify-between gap-3",
})``;

export const SessionManagementModalGlobalActions = styled.div.attrs({
  className: "flex flex-wrap gap-3",
})``;

export const SessionManagementModalSecondaryButton = styled.button.attrs({
  className: "brand-button-secondary inline-flex items-center gap-2",
})``;

export const SessionManagementModalDangerButton = styled.button.attrs({
  className: "brand-button-danger inline-flex items-center gap-2",
})``;

export const SessionManagementModalEmptyStatePanel = styled.div.attrs({
  className:
    "rounded-3xl border border-dashed border-[var(--brand-border)] bg-[rgba(255,255,255,0.03)] px-6 py-12 text-center",
})``;

export const SessionManagementModalEmptyStateTitle = styled.p.attrs({
  className: "text-lg font-semibold text-[var(--brand-ink)]",
})``;

export const SessionManagementModalEmptyStateDescription = styled.p.attrs({
  className: "mt-2 text-sm text-[var(--brand-muted)]",
})``;

export const SessionManagementModalSkeletonCard = styled.div.attrs({
  className:
    "space-y-3 rounded-3xl border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] px-5 py-4",
})``;

export const SessionManagementModalSkeletonLine = styled(SkeletonBlock).attrs({
  className: "h-5 w-32 rounded-full",
})``;

export const SessionManagementModalSkeletonLineSecondary = styled(SkeletonBlock).attrs({
  className: "h-4 w-48 rounded-full",
})``;

export const SessionManagementModalSkeletonLineTertiary = styled(SkeletonBlock).attrs({
  className: "h-4 w-36 rounded-full",
})``;
